var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import ReactDOM from 'react-dom';
import { props } from './props';
import './styles.scss';
import { NissanIwa } from "./NissanIwa";
ReactDOM.render(React.createElement(NissanIwa, __assign({}, props)), document.getElementById('root'));
